import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class CharaChange {
    constructor() {
        this.timer = [];
        this.init();
    }

    init() {
        this.eventBind();
        this.setNavHeight();
        this.stickyNav();
    }

    stickyNav() {
        const mvend = document.querySelector(".movie");
        const stickyElms = [...document.querySelectorAll(".js-mvsticky")];
        //const fxdShare = document.querySelector(".l-fxdshare");

        //初期化
        stickyElms.forEach((el) => el.classList.add("-fixed"));
        //fxdShare.classList.remove("-active");

        ScrollTrigger.create({
            trigger: mvend,
            start: "top 100%",
            //markers: true,
            onEnter: () => {
                stickyElms.forEach((el) => el.classList.remove("-fixed"));
                //fxdShare.classList.add("-active");
            },
            onLeaveBack: () => {
                stickyElms.forEach((el) => el.classList.add("-fixed"));
                //fxdShare.classList.remove("-active");
            },
        });
    }

    setNavHeight() {
        const nav = document.querySelector(".mainvisual__change__row");

        const set = () => {
            document.documentElement.style.setProperty("--navHeight", `${nav.offsetHeight}px`);
        };

        set();
    }

    clearTimer() {
        this.timer.forEach((timer) => {
            clearTimeout(timer);
        });
    }

    eventBind() {
        const mainvisual = document.querySelector(".mainvisual");
        const btn = [...document.querySelectorAll(".js-charachangebtn")];
        const curtain = document.querySelector(".mainvisual__change__curtain");
        let lastCharacter = document.body.getAttribute("data-character") || "all";

        //init
        const firstbtn = [...document.querySelectorAll(`.js-charachangebtn[data-character="${lastCharacter}"]`)];
        firstbtn.forEach((el) => el.classList.add("-active"));

        const btnwrap = document.querySelector(".mainvisual__change");

        //SPでの開閉function
        btnwrap.addEventListener("click", () => {
            if (window.innerWidth <= 834) {
                btnwrap.classList.toggle("-open");
            }
        });

        btn.forEach((el) => {

            el.addEventListener("click", () => {
                const currentCharacter = el.getAttribute("data-character");

                if (currentCharacter === lastCharacter || (window.innerWidth <= 834 && !el.closest(".mainvisual__change").classList.contains("-open"))) {
                    return;
                }

                mainvisual.classList.remove("-change");
                this.clearTimer();

                btn.forEach((el) => el.classList.remove("-active"));
                el.classList.add("-active");

                curtain.classList.add("-anim");
                document.body.setAttribute("data-character", currentCharacter);

                this.timer.push(
                    setTimeout(() => {
                        mainvisual.classList.add("-change");
                    }, 1)
                );

                //終了処理
                this.timer.push(
                    setTimeout(() => {
                        lastCharacter = currentCharacter;
                    }, 100)
                );
            });
        });

        curtain.addEventListener("animationend", () => {
            curtain.classList.remove("-anim");
        });
    }
}
